import { Skeleton } from "@postdaily/ui/components/skeleton";
import { createFileRoute } from "@tanstack/react-router";

import { BrandVoiceForm } from "@/components/ai/brand-voice-form";
import { PageHeader } from "@/components/page-header";
import { useCurrentWorkspace } from "@/hooks/use-current-workspace";

export const Route = createFileRoute("/(app)/settings/ai")({
  component: RouteComponent,
});

function RouteComponent() {
  const { currentWorkspace } = useCurrentWorkspace();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        size="lg"
        title="AI & Brand voice"
        description="Teach the composer's assistant how this workspace sounds. It applies to every generation, for every member."
      />
      {currentWorkspace ? (
        <BrandVoiceForm workspaceId={currentWorkspace.id} />
      ) : (
        <Skeleton className="h-96 w-full" />
      )}
    </div>
  );
}
